import Main from '@/views/administracion/configuracion/catalogos/entesfiscalizadores/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/entesfiscalizadores/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const entesFiscalizadores = [
  {
    path: 'entes-fiscalizadores',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoEntesFiscalizadores',
        path: '/',
        meta: {
          title: 'EntesFiscalizadores',
          auth,
          scopes,
        },
        component: Default,
      },
    ],
  },
];

export default entesFiscalizadores;
